import TableOperationUtils from '../table-operation-utils';
function primary() {
    return function (target, propertyName) {
        var property = TableOperationUtils.createPropertyInfo(propertyName);
        property.isPrimaryKey = true;
        TableOperationUtils.addTablePropertyInfo(target, property);
    };
}
export default primary;
//# sourceMappingURL=primary.js.map